/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Await_Table_Col_MissingInputs */

const vi_await_table_col_missing = /** @type {(inputs: Await_Table_Col_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Còn thiếu`)
};

/**

* @param {Await_Table_Col_MissingInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const await_table_col_missing = /** @type {((inputs?: Await_Table_Col_MissingInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Await_Table_Col_MissingInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_await_table_col_missing(inputs)
});